import React, { useState } from "react";

import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from "recharts";

const BarSCD = ({ dataBar }) => {
  const COLORS = ["#8884d8", "#9CAFAA", "#ACE2E1", "#67C6E3", "#9BB0C1"];

  return (
    <ResponsiveContainer width="100%" height={210}>
      <ComposedChart
        layout="vertical"
        data={dataBar}
        margin={{ top: 15, right: 30, bottom: 10, left: 40 }}
      >
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis type="number" />
        <YAxis dataKey="name" type="category" />
        <Tooltip formatter={value => [`${Number(value).toFixed(2)} MB`, ""]} />

        <Bar
          name="ทุนวิจัย (ล้านบาท)"
          dataKey="value"
          label={{ position: "right" }}
        >
          {dataBar.map((entry, index) =>
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          )}
        </Bar>
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default BarSCD;
